import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { routes } from "../constants/routes";
import { useDispatch } from "react-redux";
import * as CONSTANTS from "../redux/Models/Application/constants";
import HeaderLogo from "../components/Logo/HeaderLogo";
import { Modal } from "react-bootstrap";
import GGPinControl from "../components/Common/GGPinControl";
import { injectModels } from "../redux/injectModels";

function VerifyCodePopup(props) {
  const [error, setError] = useState("");
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [pinModel, SetPinModel] = useState([
    { isActive: true, digit: "", placeholder: "" },
    { isActive: false, digit: "", placeholder: "" },
    { isActive: false, digit: "", placeholder: "" },
    { isActive: false, digit: "", placeholder: "" },
    { isActive: false, digit: "", placeholder: "" },
    { isActive: false, digit: "", placeholder: "" },
  ]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFirstLoad) {
      setFirstLoad(false);
      SetPinModel([
        { isActive: true, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
      ]);
    }
  }, [isFirstLoad]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    var isEmptyPin = pinModel.filter((pin) => pin?.digit?.length === 0);
    if (isEmptyPin?.length > 0) {
      setError("Please enter valid pins");
    } else {
      var pinValue = "";
      pinModel.forEach((pin) => {
        pinValue += pin?.digit;
      });
      const data = {
        userId: props.application?.userId,
        twoFactorCode: pinValue,
      };
      try {
        props.application.setLoading(true);
        const res = await props.auth.userLogin(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          setFirstLoad(true);
          toast.success("Sign in successfully");
          dispatch({
            type: CONSTANTS.VERIFY_MODAL_TOGGLE,
            payload: { value: false },
          });
          const returnUrl = localStorage.getItem("returnUrl");
          if (returnUrl && returnUrl.length > 10) {
            localStorage.removeItem("returnUrl");
            navigate(returnUrl);
          } else {
            navigate(routes.DEFAULT);
          }
          setError("");
        } else {
          props.application.setLoading(false);
          setError(res?.message ||res?.Errors?.[0]?.Message);
          localStorage.clear();
          toast.error(res?.message ||res?.Errors?.[0]?.Message || "Something went wrong");
          return;
        }
      } catch (err) {
        props.application.setLoading(false);
        setError(err?.message);
        toast.error(err?.message);
      }
    }
  };

  return (
    <Modal
      show={props.application?.isVerifyShow}
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header
        onHide={() => {
          setError("");
           SetPinModel([
        { isActive: true, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
        { isActive: false, digit: "", placeholder: "" },
      ]);
          dispatch({
            type: CONSTANTS.VERIFY_MODAL_TOGGLE,
            payload: { value: false },
          });
        }}
        closeButton
      ></Modal.Header>
      <Modal.Body style={{ alignItems: "center", textAlign: "center" }}>
        <section className="loginswallow">
          <div
            className="form-container"
            id="form-container"
            style={{ margin: "auto" }}
          >
            <form id="login-form" onSubmit={handleSubmit}>
              <HeaderLogo></HeaderLogo>
              <h3>Verify code</h3>
 {/* if(index - 1>=0) {
                    pinModel[index - 1].isActive = true;
                    } */}
              <GGPinControl
                isSecure
                onBackPressed={(index, digit) => {
                  if (index > 0 && pinModel[index]?.digit?.length === 0) {
                    var newPinModel = [];
                    SetPinModel(newPinModel);
                    pinModel[index].digit = digit;
                    pinModel[index].isActive = false;                   
                    pinModel[index - 1].isActive = true;
                  
                    pinModel.forEach((pin, index) => {
                      newPinModel.push(pin);
                    });
                    SetPinModel(newPinModel);
                  }
                }}
                onEnterDigit={(index, digit, ref) => {
                  if (index <= pinModel.length - 1) {
                    var newPinModel = [];
                    SetPinModel(newPinModel);
                    pinModel[index].digit = digit;
                    pinModel[index].placeholder = digit?.length > 0 ? "•" : "0";
                    pinModel[index].isActive = false;
                    if (index !== pinModel.length - 1) {
                      pinModel[index + 1].isActive = true;
                    }

                    pinModel.forEach((pin, index) => {
                      newPinModel.push(pin);
                    });
                    SetPinModel(newPinModel);
                    if (index === pinModel.length - 1) {
                      ref?.current?.blur();
                    }
                  }
                }}
                textColor="#000000"
                roundeStyle={{
                  backgroundColor: "#e1e1e1",
                  borderRadius: 5,
                  borderWidth: 2,
                }}
                digits={pinModel}
              ></GGPinControl>

              {error && (
                <p
                  className="text-danger"
                  style={{ textAlign: "center", marginTop: 10 }}
                >
                  {error}
                </p>
              )}

              <button type="submit">Verify</button>
            </form>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
}
export default injectModels(["application", "auth"])(VerifyCodePopup);
